import LatoRegular from '../fonts/Lato-Regular.ttf'
import PoppinsBold from '../fonts/Poppins-Bold.ttf'

const latoLight = {
  fontFamily: 'LatoRegular',
  src: `local('LatoRegular'),url(${LatoRegular}) format('woff2')`,
}

const poppinsBold = {
  fontFamily: 'PoppinsBold',
  src: `local('PoppinsBold'),url(${PoppinsBold}) format('woff2')`,
}

export const EUSKALTEL_THEME = {
  palette: {
    primary: { main: '#ff5800', light: '#f7e0d0', black: '#000000' },
    secondary: {
      contrastText: '#fff',
      main: '#000000',
    },
    disabled: {
      alternativeDisableColor: '#ff5800',
      text: '#BBBDBD',
      background: '#E1E3E3',
    },
    secondaryTitle: {
      main: '#c3c3c3',
    },
    icon: {
      main: '#ff5800',
    },
    menu: { main: '#ff5800' },
    header: {
      background: '#ff5800',
      text: '#fff',
    },
    headerLinks: {
      background: '#444444',
      text: '#ffffff',
      hover: '#ff5800',
    },
    footer: {
      main: '#bfbfbf',
      background: '#333333',
      icons: '#bfbfbf',
      hover: '#ff5800',
    },
    button: {
      color: '#fff',
      backgroundColor: '#ff5800',
      hoverColor: '#ff5800',
      hoverBackgroundColor: '#fff',
      hoverBorderColor: '#ff5800',
    },
    table: {
      headerText: '#9b9b9b',
    },
    success: { main: '#00D41F' },
    warning: { main: '#EEC303' },
    error: { main: '#FF0000' },
    info: { main: '#008DFF' },
    breadcrumb: {
      color: '#ff5800',
      backgroundColor: '#fff',
    },
    user: {
      icon: '#ff5800',
      background: '#ffffff',
    },
    langBar: {
      backgroundColor: '#5c5c5c',
      color: 'black',
    },
    switchColor: {
      color300: '#ff5800',
      color500: '#ff935b',
    },
  },
  typography: {
    h1: {
      fontFamily: 'poppinsBold',
      fontSize: '1.75rem',
    },
    h2: {
      fontFamily: 'poppinsBold',
      fontSize: '1.5rem',
    },
    h3: {
      fontFamily: 'latoRegular',
      fontSize: '1.2rem',
    },
    h4: {
      fontFamily: 'poppinsBold',
      fontSize: '1.2rem',
    },
    h5: {
      fontFamily: 'poppinsBold',
      fontSize: '1.1rem',
    },
    h6: {
      fontFamily: 'latoRegular',
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    body1: {
      fontFamily: 'latoRegular',
      fontSize: '1rem',
    },
    body2: {
      fontFamily: 'latoRegular',
      fontSize: '0.9rem',
    },
    subtitle1: {
      fontFamily: 'latoRegular',
      fontSize: '0.7rem',
    },
    subtitle2: {
      fontFamily: 'latoRegular',
      fontSize: '0.65rem',
      fontWeight: 600,
    },
  },
  borderBottom: {
    borderBottom: '4px solid #ff5800',
  },
  borderTopMainMenu: {
    borderTop: '0px solid #ff5800',
  },
  footerShadow: {
    boxShadow: 'none',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [latoLight, poppinsBold],
        body: {
          minWidth: '289px',
          width: '100%',
          fontSize: '0.875rem',
          lineHeight: '1.43rem',
          backgroundColor: 'white',
        },
        main: {
          width: '100%',
        },
        ' .grecaptcha-badge': {
          display: 'none',
        },
        '.fullButton, .emptyButton': {
          minHeight: '2rem !important',
          minWidth: '8rem !important',
          width: 'auto !important',
        },
        '.MuiPaper-rounded': {
          borderRadius: '10px !important',
        },
        '.MuiAppBar-root': {
          display: 'block',
        },
        '.MuiPickersDay-day.MuiPickersDay-daySelected > .MuiIconButton-label > .MuiTypography-root': {
          color: '#fff !important',
        },
        '.MuiButton-root': {
          backgroundColor: '#F60',
          margin: '5px 5px 5px 0px',
          fontFamily: 'latoRegular !important',
          '&:hover': {
            color: '#ff5800 !important',
          },
          '&:disabled': {
            backgroundColor: 'rgba(0,0,0,0.12)',
          },
        },
        '.MuiIconButton-root': {
          color: '#ff5800 !important',
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        '.MuiButton-textSizeSmall': {
          height: '22px',
        },
        '.textErrorsColors': {
          color: 'red',
        },
        '.MuiContainer-root': {
          margin: '20px',
          marginBottom: '6.5rem',
        },
        '.MuiDataGrid-footerContainer': {
          position: 'relative',
          top: '15px',
        },
        '.messagesErrorInvoiceContainer': {
          paddingTop: '5px',
        },
        '.MuiCardHeader-content > p': {
          marginTop: '5px',
        },
        '.MuiCardHeader-avatar': {
          marginRight: '3px !important',
        },
        '.MuiDataGrid-root': {
          border: 'none !important',
        },
        '.MuiCardContent-root:last-child': {
          padding: '16px !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-row.Mui-selected:hover': {
          'background-color': 'rgba(73, 73, 73, 0.12) !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-row.Mui-selected': {
          'background-color': 'rgba(99, 99, 99, 0.08) !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnSeparator': {
          display: 'none !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnsContainer': {
          'background-color': 'trasparent !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer': {
          'padding-left': '0rem !important',
          'padding-right': '0rem !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnHeaderCheckbox': {
          'padding-right': '0rem !important',
        },
        '.MuiPaper-elevation1': {
          'box-shadow': '0px 0px 13px 3px rgb(0 0 0 / 10%) !important',
        },
        '.buttons': {
          'margin-top': '0px !important',
          'flex-direction': 'row !important',
          'justify-content': 'flex-start !important',
        },
        '.MuiMenu-paper': {
          zIndex: 9999,
        },
        '.MuiDialogContent-root': {
          overflowY: 'visible !important',
          margin: '1rem',
        },
        '*::-webkit-scrollbar': {
          width: 5,
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          background: '#F60',
        },
      },
    },
  },
}
